"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 15px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  z-index: initial !important;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));

var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));

var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));

var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));

var utils_1 = __importDefault(require("@nexys/utils"));

var Errors = function Errors(props) {
  var name = props.name,
      errors = props.errors;

  if (!errors || !name || !(name in errors)) {
    return null;
  }

  var errorArr = utils_1.default.ds.get(name, errors);
  var errorMsg = errorArr.join(', ');
  return react_1.default.createElement(FormHelperText_1.default, {
    style: {
      fontSize: 14,
      color: 'red'
    }
  }, errorMsg);
};

var Label = function Label(props) {
  var label = props.label,
      name = props.name,
      shrink = props.shrink;

  if (!label) {
    return null;
  }

  return react_1.default.createElement(InputLabel_1.default, {
    htmlFor: name,
    shrink: shrink
  }, label);
};

var Wrapper = function Wrapper(props) {
  var label = props.label,
      name = props.name,
      errors = props.errors,
      mandatory = props.mandatory,
      children = props.children,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      inputId = props.inputId,
      shrink = props.shrink,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type;
  var strName = name.toString();
  var control = react_1.default.createElement(StyledFormControl, {
    required: mandatory,
    fullWidth: true,
    label: label
  }, react_1.default.createElement(Label, {
    name: inputId ? inputId : strName,
    label: label,
    shrink: shrink
  }), children, react_1.default.createElement(Errors, {
    name: strName,
    errors: errors
  }));

  if (type === 'checkbox' || type === 'switch') {
    control = react_1.default.createElement(StyledFormControl, {
      required: mandatory,
      fullWidth: true,
      label: label
    }, react_1.default.createElement(FormLabel_1.default, null, label, children), react_1.default.createElement(Errors, {
      name: strName,
      errors: errors
    }));
  }

  if (type === 'date' || type === 'autocomplete') {
    control = react_1.default.createElement(StyledFormControl, {
      required: mandatory,
      fullWidth: true,
      label: label
    }, react_1.default.cloneElement(children, {
      label: label
    }), react_1.default.createElement(Errors, {
      name: strName,
      errors: errors
    }));
  }

  if (inline) {
    return control;
  } else {
    return react_1.default.createElement(FormControlWrapper, null, control);
  }
};

var StyledFormControl = styled_components_1.default(FormControl_1.default)(_templateObject(), function (props) {
  return props.label && "\n    label {\n      padding-left: 10px;\n    }\n  ";
});
var FormControlWrapper = styled_components_1.default.div(_templateObject2());
exports.default = Wrapper;